import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app.settings';
import { CancelReason } from 'src/app/core/interfaces/cancel-reason';
import { ConfirmBoxData } from 'src/app/core/interfaces/confirm-box-data';
import { AppData } from 'src/app/app.data';
import { ConfirmBoxAction } from 'src/app/core/enums';

@Component({
  selector: 'app-confirm-box',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['./confirm-box.component.scss']
})
export class ConfirmBoxComponent  {
  
  public cancelReasons: CancelReason[];
  public actionType: ConfirmBoxAction;
  public alsoDeleteTreatments: boolean;
  public DELETE_WL_ACTION: number;
  public DELETE_APPT_ACTION: number;

  constructor(
    public appSettings:AppSettings,
    private appData: AppData,
    public dialogRef: MatDialogRef<ConfirmBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmBoxData){

      this.cancelReasons = appData.cancelReasons;
      this.DELETE_APPT_ACTION = ConfirmBoxAction.DeleteAppointment;
      this.DELETE_WL_ACTION = ConfirmBoxAction.DeleteWaitlistItem;
      this.actionType = this.data.actionType;
      this.alsoDeleteTreatments = this.data.alsoDeleteTreatments;
      
    } 


  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmSelection() {    
    this.dialogRef.close();
  }

  getData(){
    // not other
    if(this.data.cancelReasonID > 1 || this.actionType == this.DELETE_WL_ACTION){
      return this.data;
    } else if(this.data.cancelReason){
      return this.data;
    }
    return false;
  }

  isValid(){
    if(this.data.cancelReasonID > 1 || this.actionType === this.DELETE_WL_ACTION){
      return true;
    } else if(this.data.cancelReason){
      return true; // if selected 'other' then must enter description
    }
    return false; 
  }
}
